<template>
  <div class="card mb-3 shadow" style="max-width:400px;">
    <div class="card-body">
      <h5 class="card-title mb-2"><i class="bi bi-lightning-charge"></i> {{ device.name }}</h5>
      <div class="mb-1 small text-muted">ID: {{ device.shelly_id }}</div>
      <div class="mb-2">
        <span class="badge me-1" :class="isOnline ? 'bg-success' : 'bg-danger'">
          {{ isOnline === null ? "..." : isOnline ? "Online" : "Offline" }}
        </span>
        <span class="badge bg-info">Medidor Trifasico</span>
      </div>
      <!-- Temperatura -->
      <div v-if="tempC !== null" class="mb-2">
        <small>
          <i class="bi bi-thermometer-half"></i>
          {{ tempC.toFixed(1) }}°C / {{ tempF.toFixed(1) }}°F
        </small>
      </div>
      <!-- Resumen total -->
      <div class="mb-3">
        <b>Total Corriente:</b> {{ em0.total_current }} A <br>
        <b>Total Potencia activa:</b> {{ em0.total_act_power }} W <br>
        <b>Total Potencia aparente:</b> {{ em0.total_aprt_power }} VA
      </div>
      <!-- Tabla de fases -->
      <div class="table-responsive mb-2">
        <table class="table table-sm table-bordered mb-0">
          <thead class="table-light">
            <tr>
              <th></th>
              <th>Corriente (A)</th>
              <th>Voltaje (V)</th>
              <th>Potencia (W)</th>
              <th>Aparente (VA)</th>
              <th>FP</th>
              <th>Hz</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Fase A</th>
              <td>{{ em0.a_current }}</td>
              <td>{{ em0.a_voltage }}</td>
              <td>{{ em0.a_act_power }}</td>
              <td>{{ em0.a_aprt_power }}</td>
              <td>{{ em0.a_pf }}</td>
              <td>{{ em0.a_freq }}</td>
            </tr>
            <tr>
              <th>Fase B</th>
              <td>{{ em0.b_current }}</td>
              <td>{{ em0.b_voltage }}</td>
              <td>{{ em0.b_act_power }}</td>
              <td>{{ em0.b_aprt_power }}</td>
              <td>{{ em0.b_pf }}</td>
              <td>{{ em0.b_freq }}</td>
            </tr>
            <tr>
              <th>Fase C</th>
              <td>{{ em0.c_current }}</td>
              <td>{{ em0.c_voltage }}</td>
              <td>{{ em0.c_act_power }}</td>
              <td>{{ em0.c_aprt_power }}</td>
              <td>{{ em0.c_pf }}</td>
              <td>{{ em0.c_freq }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- Energía acumulada -->
      <div class="mt-3">
        <b>Energía acumulada (kWh)</b>
        <ul class="mb-1">
          <li>Fase A: {{ emdata0.a_total_act_energy }}</li>
          <li>Fase B: {{ emdata0.b_total_act_energy }}</li>
          <li>Fase C: {{ emdata0.c_total_act_energy }}</li>
          <li><b>Total: {{ emdata0.total_act }}</b></li>
        </ul>
        <div v-if="emdata0.total_act_ret > 0">
          <small>Retornada: {{ emdata0.total_act_ret }} kWh</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../api/api";
export default {
  props: ["device"],
  data() {
    return {
      isOnline: null,
      tempC: null,
      tempF: null,
      em0: {},
      emdata0: {},
    };
  },
  methods: {
    async getStatus() {
      try {
        let res = await api.deviceStatus(this.device.id);
        if (typeof res === "string") res = JSON.parse(res);
        let d = res.data?.data ? res.data.data : res.data ? res.data : res;
        this.isOnline = d.online ?? null;
        // Datos principales de em:0
        this.em0 = d.device_status && d.device_status["em:0"] ? d.device_status["em:0"] : {};
        // Energía acumulada
        this.emdata0 = d.device_status && d.device_status["emdata:0"] ? d.device_status["emdata:0"] : {};
        // Temperatura
        if (d.device_status && d.device_status["temperature:0"]) {
          this.tempC = d.device_status["temperature:0"].tC;
          this.tempF = d.device_status["temperature:0"].tF;
        } else {
          this.tempC = null;
          this.tempF = null;
        }
      } catch (e) {
        this.isOnline = null;
        this.tempC = null;
        this.tempF = null;
        this.em0 = {};
        this.emdata0 = {};
      }
    },
    startAutoRefresh() {
      this.refreshTimer = setInterval(() => {
        this.getStatus();
      }, 8000);
    },
    stopAutoRefresh() {
      if (this.refreshTimer) clearInterval(this.refreshTimer);
    }
  },
  mounted() {
    this.getStatus();
    this.startAutoRefresh();
  },
  beforeUnmount() {
    this.stopAutoRefresh();
  }
};
</script>
